import { Component } from 'react'
import PropTypes from 'prop-types'

class PlayableManager extends Component {
    constructor(props) {
        super(props)

        // Expose the commands to dev console
        window.setPlayable = this.setPlayable
    }

    shouldComponentUpdate() {
        return false
    }

    setPlayable = (serverId, playable) => {
        // TODO: 2018-08-22 baldvinth - Re-enable this when the backend has been fixed
        // (todo-list-setPlayable)
        if (serverId || !serverId) return null

        this.props.setPlayable(serverId, playable)
    }

    render() {
        return null
    }
}

PlayableManager.propTypes = {
    setPlayable: PropTypes.func,
}

export default PlayableManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/PlayableManager/component.js